var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-container", [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c(
            "div",
            { staticClass: "column w-75" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "mt-4 d-flex align-items-start justify-content-between"
                },
                [
                  _c("back-arrow", {
                    attrs: { title: _vm.$t("my.matches.title") }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.isLoading
                ? _c(
                    "transition-group",
                    {
                      attrs: {
                        appear: "",
                        name: "listCustomTransition",
                        tag: "div"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          key: "my-matches-PlaceHolder-draft",
                          staticClass:
                            "d-flex flex-column justify-content-center mt-4 m b-4"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "matches-title mt-2 mb-2" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("my.matches.current.matches")) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: true,
                              isGradient: false,
                              customDisplayClass: "my-matches-placeholder mb-2"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "matches-title mt-4 mb-2" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("my.matches.validated.matches")
                                  ) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: true,
                              isGradient: false,
                              customDisplayClass: "my-matches-placeholder mb-2"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "matches-title mt-4 mb-2" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("my.matches.refused.matches")) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: true,
                              isGradient: false,
                              customDisplayClass: "my-matches-placeholder mb-2"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isLoading
                ? _c(
                    "transition-group",
                    { attrs: { name: "listCustomTransition" } },
                    [
                      _c(
                        "div",
                        {
                          key: "my-matches-draft",
                          staticClass:
                            "d-flex flex-column justify-content-center mt-4 m b-4"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "matches-title mt-2 mb-2" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("my.matches.current.matches")) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.currentMatches, function(currentMatch) {
                            return _vm.currentMatches.length > 0
                              ? _c("matches-card-image", {
                                  key: currentMatch.serverId,
                                  staticClass: "mb-2",
                                  attrs: { match: currentMatch }
                                })
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _vm.currentMatches.length === 0
                            ? _c("div", { staticClass: "card-container" }, [
                                _c("div", { staticClass: "d-flex" }, [
                                  _c("div", { staticClass: "p-3" }, [
                                    _c("img", {
                                      staticClass: "empty-state-img-home",
                                      attrs: {
                                        src: require("@/assets/images/b122/img-confused.png"),
                                        alt: "no result"
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "empty-state-text" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "my.matches.no.current.matches"
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "matches-title mt-4 mb-2" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("my.matches.validated.matches")
                                  ) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.validatedMatches, function(
                            validatedMatch
                          ) {
                            return _vm.validatedMatches.length > 0
                              ? _c("matches-card-image", {
                                  key: validatedMatch.serverId,
                                  staticClass: "mb-2",
                                  attrs: { match: validatedMatch }
                                })
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _vm.validatedMatches.length === 0
                            ? _c("div", { staticClass: "card-container" }, [
                                _c("div", { staticClass: "d-flex" }, [
                                  _c("div", { staticClass: "p-3" }, [
                                    _c("img", {
                                      staticClass: "empty-state-img-home",
                                      attrs: {
                                        src: require("@/assets/images/b122/img-confused.png"),
                                        alt: "no result"
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "empty-state-text" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "my.matches.no.validated.matches"
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "matches-title mt-4 mb-2" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("my.matches.refused.matches")) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isLoading
                            ? _c("PlaceholderCardAnnonce", {
                                attrs: {
                                  isAnimated: true,
                                  isGradient: false,
                                  customDisplayClass:
                                    "my-matches-placeholder mb-2"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.refusedMatches, function(refusedMatch) {
                            return _vm.refusedMatches.length > 0
                              ? _c("matches-card-image", {
                                  key: refusedMatch.serverId,
                                  staticClass: "mb-2",
                                  attrs: { match: refusedMatch }
                                })
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _vm.refusedMatches.length === 0
                            ? _c("div", { staticClass: "card-container" }, [
                                _c("div", { staticClass: "d-flex" }, [
                                  _c("div", { staticClass: "p-3" }, [
                                    _c("img", {
                                      staticClass: "empty-state-img-home",
                                      attrs: {
                                        src: require("@/assets/images/b122/img-confused.png"),
                                        alt: "no result"
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "empty-state-text" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "my.matches.no.refused.matches"
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50a4839d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50a4839d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/MyMatches.vue
// module id = 4ohi
// module chunks = 0